import { featuresList } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-star-line"></i>
            平台优势
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择51吃瓜网
          </h2>
          <p className="text-sm text-foreground-500 mt-2">四大核心优势，打造极致吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresList.map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}